import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

import "./Faq.css";

const data = [
  {
    q: "Is the project approved?",
    a: "Yes. Documentation and approvals will be shared during booking. We keep the buying process transparent and simple.",
  },
  {
    q: "Can I get the floor plan and complete payment schedule?",
    a: "Yes. Request it from the contact form and we’ll share the full schedule along with available layouts and unit sizes.",
  },
  {
    q: "Is there parking and security?",
    a: "Yes. Dedicated parking and 24/7 security monitoring are part of the plan, with controlled building access.",
  },
  {
    q: "When is possession expected?",
    a: "Current target is Q4 2028. Timelines can be refined as construction progresses — we’ll keep it updated.",
  },
  // {
  //   q: "How do I book a site visit?",
  //   a: "Use the “Book a Site Visit” button and we’ll confirm your slot. Later we’ll connect it with the backend booking API.",
  // },
];

const Faq = () => {
  const { ref, inView } = useInView({ threshold: 0.18, triggerOnce: true });
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <section className="faq" id="faq" ref={ref}>
      <div className="faq__container">
        <motion.div
          className="faq__head"
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          <div className="faq__kicker">FAQ</div>
          <h2 className="faq__title">Quick answers, no guesswork.</h2>
          <p className="faq__sub">
            If you need anything specific, we’ll share exact details on call or WhatsApp.
          </p>
        </motion.div>

        <div className="faq__grid">
          {data.map((item, idx) => {
            const active = openIndex === idx;

            return (
              <motion.div
                key={idx}
                className={`faq__item ${active ? "is-active" : ""}`}
                initial={{ opacity: 0, y: 10 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.55, delay: 0.05 * idx }}
              >
                <button className="faq__q" type="button" onClick={() => toggle(idx)}>
                  <span>{item.q}</span>
                  <span className="faq__icon">
                    {active ? <RemoveRoundedIcon /> : <AddRoundedIcon />}
                  </span>
                </button>

                <AnimatePresence initial={false}>
                  {active && (
                    <motion.div
                      className="faq__aWrap"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.28, ease: "easeOut" }}
                    >
                      <div className="faq__a">{item.a}</div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
